import { Component, Input } from '@angular/core';
import { AppNotification } from '../../services/notification.service';

@Component({
  selector: 'lgn-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent {
  @Input() notification: AppNotification;

  get iconName(): string {
    switch (this.notification.type) {
      case 'success':
        return 'check-circle-outline';
      case 'error':
        return 'warning';
      default:
        return null;
    }
  }
}
